<template>
  <div class="storemanageAPP" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div style="height:15px"></div>
    <div class="header">
      <div class="bg" :style="'background:url('+bg+');background-size:100% 100%;'">
        <div class="headCon">
          <img class="avatar" :src="userData.avatar" />
          <p>{{userData.username}}<b>加入时间:{{userData.createtime}}</b></p>
          <!--<div class="status" @click="addStore">
            <img src="~assets/images/qrcode.png">
            添加
          </div>-->
        </div>
      </div>
      <div class="info">
        <div class="item-list" @click="toPush(store_id,'storetotal')">
          <p>{{total}}</p>
          <p>总订单</p>
        </div>
        <div class="item-list" @click="toPush(store_id,'staff')">
          <p>{{totalNew}}</p>
          <p>员工管理</p>
        </div>
        <div class="item-list" @click="toPush(store_id,'goods')">
          <p>{{prototal}}</p>
          <p>物品管理</p>
        </div>
        <div class="item-list" @click="toPush(store_id,'storeuser')">
          <p>{{adminTotal}}</p>
          <p>管理员</p>
        </div>
      </div>
    </div>
    <div style="height:10px;"></div>
    <div class="pro" v-for="(item,i) in detail">
      <div class="bussTitle">
        <div class="simg" :style="'background:url('+baseUrl+item.logo+') no-repeat center;background-size:100%'"></div>
        <!--<img :src="baseUrl+item.logo" />-->
        <div class="name">
          <p>{{item.stitle}}</p>
          <p>商品编号：{{item.number}}</p>
        </div>
        <div class="status" :style="item.status == 1 ? 'color:#f00' : ''">{{item.status == 1 ? '已支付' : '已归还'}}</div>
      </div>
      <div class="goods">
        <div class="left" :style="'background:url('+baseUrl+item.image+') no-repeat center;background-size:100%'"></div>
        <!--<img class="left" :src="baseUrl+item.image" />-->
        <div class="right">
          <p>{{item.title}}</p>
          <div class="num">购买数量：{{item.num}}件</div>
          <div class="price">
            <i>￥</i><b>{{item.price.split(".")[0]}}</b>
            <i>.{{item.price.split(".")[1]}}</i>
          </div>
        </div>
      </div>
      <div class="email">
        姓名 
        <span>{{item.name}}</span>
      </div>
      <div class="email">
        购买时间 
        <span>{{item.createtime}}</span>
      </div>
      <div class="email" >
        优惠劵 
        <span style="color:#f00">-￥{{coupon}}</span>
      </div>
      <div class="email" style="color:#fff;border-bottom:none">
        <a v-if="item.status == 1" @click="ysgoods(item.id)">立即验收</a>
        <a v-if="item.status == 2" @click="toPush(item.id,'warestore')">查看验收结果</a>
        <span class="curt">总金额：￥{{item.price - coupon}}元</span>
      </div>
    </div>



    <div style="height:50px"></div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        detail:[],
        business:[],
        userData:[],
        total:0,
        totalNew:0,
        prototal:0,
        bg:require( '../../assets/images/lock_bg.png'),
        coupon:0,
        store_id:0,
        adminTotal:0
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
    },
    created(){
      this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
    },
    mounted() {
      this.beforeMount();
      this.getDetail();
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },
      ysgoods:function(order_id){
        window.location.href="http://user.4008005216.com/main/ware?id="+order_id
      },
      getDetail:function(){
        var that = this;
        that.fullscreenLoading = true
        var phone = this.$route.query.id;
        this.axios({
          method:'post',
          url:that.$host+'home/store/manage',
          params:{
            user_id:that.userData.id
          }
        }).then(function(response){
          var res = response.data.data;
          that.detail = res.rs;
          that.prototal = res.total;
          that.total = res.order;
          that.totalNew = res.orderNew;
          that.adminTotal = res.adminTotal;
          that.store_id = res.store_id;

          that.fullscreenLoading = false
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },

    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .storemanageAPP{
    max-width:640px;
    background:#F7FAFF;
    margin:0 auto;
  }

  .storemanageAPP .header{
    width:94%;
    height:160px;
    display:block;
    margin:0 auto;
    background:#fff;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.2);
    border-radius: 10px;
  }
  .storemanageAPP .header .bg{
    width: 100%;
    height: 100px;
    position: relative;
  }
  .storemanageAPP .header .bg .headCon .avatar{
    margin:15px 0 0 16px;
    padding:2px;
    float:left;
    background:#fff;
    width:70px;
    border-radius: 50%;
  }
  .storemanageAPP .header .bg .headCon p{
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #FFFEFE;
    float:left;
    margin:20px 0 0 10px;
    width:70%
  }
  .storemanageAPP .header .bg .headCon p b{
    display:block;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #FFFEFE;
    padding-top:10px;
  }

  .storemanageAPP .header .info{
    width: 100%;
    height:58px;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
  }
  .storemanageAPP .header .info .item-list{
    width:33.33%;
    text-align:center;
    position: relative;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #96BBFF;
  }
  .storemanageAPP .header .info .item-list p:first-child{
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #2F78FF;
    padding:10px 0 2px 0
  }
  .storemanageAPP .header .info .item-list:after{
    position: absolute;
    width:1px;
    height:40px;
    content:'';
    right:0;
    top:9px;
    background:#EBF2FF
  }
  .storemanageAPP .header .status{
    position: absolute;
    top:15px;
    right:15px;
    color:#fff;
    font-size:15px
  }
  .storemanageAPP .header .status img{
    display:block;
    width:20px;
    margin:0 auto 2px auto;
  }

  .storemanageAPP .header .info .item-list:last-child:after{
    background:none;
  }
  .storemanageAPP .pro{
    background:#fff;
    display:block;
    width:94%;
    border-radius: 10px;
    margin:0 auto 10px auto;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.2);
  }
  .storemanageAPP .pro .goods:after,.storemanageAPP .pro .bussTitle:after,.storemanageAPP .email:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .storemanageAPP .pro .bussTitle{
    width:92%;
    margin:0 auto;
    padding:10px 0
  }
  .storemanageAPP .pro .bussTitle .simg{
    width:50px;
    border-radius:5px;
    float:left;
    height:50px
  }
  .storemanageAPP .pro .bussTitle img{
    width:50px;
    border-radius:5px;
    float:left;
  }
  .storemanageAPP .pro .bussTitle .name{
    float:left;
    width:68%;
    margin-left:2%
  }
  .storemanageAPP .pro .bussTitle .name p{
    font-size:17px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .storemanageAPP .pro .bussTitle .name p:last-child{
    font-size:12px;
    padding-top:8px;
    color:#666
  }
  .storemanageAPP .pro .bussTitle .status{
    float:right;
    font-size:15px;
    color:#666;
    margin-top:12px;
    font-weight:bold;
  }

  .storemanageAPP .goods .left{
    float:left;
    width:16%;
    border-radius:5px;
    margin:4% 2% 2% 4%;
    height:55px;
    background-size:100% !important
  }
  .storemanageAPP .goods .right{
    float:left;
    margin-top:4%;
    width:73%;
    border-bottom:solid 1px #ebebeb;
    position: relative;
    min-height:60px;
  }
  .storemanageAPP .goods .right p{
    letter-spacing:1px;
    font-size:16px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    color:#333;
    width:78%
  }
  .storemanageAPP .goods .right p font{
    background:#f00;
    color:#fff;
    border-radius:5px;
    font-size:13px;
    position: relative;
    padding:2px;
    top:-2px;
    margin-right:2px
  }
  .storemanageAPP .goods .right .num{
    font-size: 14px;
    color: #999999;
    padding-top:13px;
  }
  .storemanageAPP .goods .right .price{
    color:#f00;
    font-size:15px;
    position: absolute;
    top:0;
    right:0;
    text-align:right
  }
  .storemanageAPP .goods .right .price div{
    font-size:12px;
    color:#999;
    text-decoration: line-through;
  }
  .storemanageAPP .goods .right .price b{
    color: #FF6600;
    font-size:18px;
    font-weight:600;
  }

  .storemanageAPP .goods .right .price i{
    color: #FF6600;
    font-size:13px;
    font-style:normal
  }
  
  .storemanageAPP .goods .right .price font{
    color:#666;
    font-size:14px;
    padding-left:8px
  }

  .storemanageAPP .email{
    background:#fff;
    padding:18px 0;
    font-size:15px;
    color:#333;
    display:block;
    width:90%;
    margin:0 auto;
    font-size: 16px;
    border-bottom:solid 1px #ebebeb;
  }
  .storemanageAPP .email span{
    color:#666;
    font-size: 15px;
    float:right;
    font-weight:normal;
  }
  .storemanageAPP .email span.curt{
    color:#f00;
    padding:2px 5px;
    border-radius:5px;
    font-size:18px;
    padding-top:8px
  }
  .storemanageAPP .email a{
    float:right;
    background:rgba(0,74,224,.7);
    padding:8px 12px;
    border-radius:5px;
    margin-left:10px;
    font-size:15px
  }
</style>